// src/pages/item_types/ItemTypeList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import itemTypeService from '../../services/itemTypeService';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';

const ItemTypeList = () => {
  const [itemTypes, setItemTypes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchItemTypes = async () => {
      const response = await itemTypeService.getItemTypes();
      setItemTypes(response.data);
    };
    fetchItemTypes();
  }, []);

  const handleDelete = async (id) => {
    await itemTypeService.deleteItemType(id);
    setItemTypes(itemTypes.filter((itemType) => itemType.id !== id));
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Product Types' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/item-types/new')}
          >
            Add Product Type
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Product Types</TableCell>
              <TableCell>Station Types</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {itemTypes.map((itemType, index) => (
              <TableRow
                key={itemType.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                  // '&:hover': { backgroundColor: '#e0f7fa' },
                }}
              >
                <TableCell>{itemType.type}</TableCell>
                <TableCell>{itemType.station_type}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => navigate(`/item-types/edit/${itemType.id}`)}
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton onClick={() => handleDelete(itemType.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default ItemTypeList;
